<template>
	<div class="eagle-tap" :class="tapClass">
		<h3 class="title" v-html="tapContext.title"></h3>
		<p class="fit-for">{{ tapContext.subTitle }}</p>
		<div class="price">
			<span class="symble">¥</span>
			<span class="money">{{ price.toFixed(2) }}</span>
		</div>
		<div class="origin-price">{{ tapContext.originPrice }}</div>
		<e-button @click="buyTapClicked" round :type="btType">{{
			tapContext.update
		}}</e-button>
		<div class="advantage">
			<h3 class="advantage-title">{{ tapContext.edition }}</h3>
			<ul class="advantage-list">
				<li>{{ tapContext.saleText1 }}</li>
				<li>{{ tapContext.saleText2 }}</li>
				<Tips
					:text="tapContext.saleText3"
					:content="tapContext.saleTip"
					:color="color"
				/>
			</ul>
			<h3 class="advantage-title">{{ extra.title }}</h3>
			<ul class="advantage-list">
				<li v-for="text in extra.list" :key="text">{{ text }}</li>
			</ul>
		</div>
	</div>
</template>
<script>
import Tips from './Tips'
import { appSale } from '../../baseData'
import buyStore from '../../../../utils/buyStore'

export default {
	data() {
		return {
			showWechatTip: false,
			coupon: null,
		}
	},
	props: {
		version: {
			type: String,
			required: true,
		},
		tapContext: {
			type: Object,
			required: true,
		},
	},
	components: {
		Tips,
	},
	computed: {
		tapClass() {
			return this.version === 'pro' ? 'eagle-pro-tap' : 'eagle-advance-tap'
		},
		btType() {
			return this.version === 'pro' ? 'default' : 'primary'
		},
		color() {
			return this.version === 'pro' ? '#fff' : '#8e8e8e'
		},
		price() {
			return buyStore.getPrice(this.version)
		},
		extra() {
			return appSale.extra
		},
	},
	methods: {
		buyTapClicked() {
			buyStore.$emit('buyTapClicked', this.version)
		},
	},
}
</script>
<style lang="scss" scoped>
.eagle-tap.eagle-pro-tap {
	background-color: #107ffc;
	.title {
		color: #fff;
	}
	.fit-for {
		color: #fff;
	}
	.price {
		color: #fff;
	}
	.origin-price {
		color: #fff;
	}
	.advantage-title {
		color: #fff;
	}
	.advantage-list {
		li {
			color: #cfe5fe;
		}
	}
}
.eagle-tap.eagle-advance-tap {
	background-color: #fff;
	border: solid 1px #ebf3ff;
	.title {
		color: #565656;
	}
	.fit-for {
		color: #8e8e8e;
	}
	.price {
		color: #107ffc;
	}
	.origin-price {
		color: #bcbcbc;
	}
	.advantage {
		border-top: 1px solid #f4f4f4;
	}
	.advantage-title {
		color: #565656;
	}
	.advantage-list {
		li {
			color: #8e8e8e;
		}
	}
	button {
		box-shadow: none;
	}
}
.eagle-tap {
	box-sizing: border-box;
	margin: 64px 28px 0;
	width: 368px;
	padding: 0 24px 40px;
	border-radius: 8px;
	box-shadow: 0 2px 64px 0 rgba(29, 91, 174, 0.4);
	border: solid 1px transparent;
	text-align: center;
	.title {
		padding-top: 40px;
		font-size: 20px;
		line-height: 24px;
	}
	.fit-for {
		margin-top: 16px;
		font-size: 12px;
		opacity: 0.8;
	}
	.price {
		margin-top: 40px;
		.symble {
			vertical-align: super;
		}
		.money {
			font-size: 56px;
			font-weight: bold;
		}
	}
	.origin-price {
		margin-top: 16px;
		font-size: 14px;
		opacity: 0.8;
		text-decoration: line-through;
	}
	button {
		margin-top: 40px;
		width: 200px;
		height: 40px;
		box-shadow: 0 8px 40px 0 rgba(0, 87, 184, 0.64);
	}
	.advantage {
		margin-top: 40px;
		border-top: 1px solid rgba(255, 255, 255, 0.2);
	}
	.advantage-title {
		text-align: left;
		margin-left: 40px;
		margin-top: 32px;
		margin-bottom: 10px;
		font-size: 14px;
	}
	.advantage-list {
		margin-left: 40px;
		text-align: left;
		li {
			margin-left: 14px;
			line-height: 24px;
			color: #cfe5fe;
			list-style-type: disc;
		}
	}
}
</style>
